
import React from 'react';
import { Project } from '@/hooks/useProjects';

interface SessionInfoProps {
  isTracking: boolean;
  currentEntryId: string | null;
  selectedProject: string;
  projects: Project[];
  startTime: Date | null;
}

const SessionInfo: React.FC<SessionInfoProps> = ({
  isTracking,
  currentEntryId,
  selectedProject,
  projects,
  startTime
}) => {
  if (!isTracking || !currentEntryId) {
    return null;
  }

  const selectedProjectData = projects.find(p => p.id === selectedProject);

  const startTimeObj = React.useMemo(() => {
    if (!startTime) return null;
    return typeof startTime === 'string' ? new Date(startTime) : startTime;
  }, [startTime]);

  return (
    <div className="text-xs text-center text-green-700 bg-green-50 p-3 rounded border border-green-200">
      💼 <strong>Shift en cours</strong><br/>
      Projet: {selectedProjectData?.name || 'N/A'}<br/>
      Démarré: {startTimeObj ? startTimeObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '—'}<br/>
      ID: {currentEntryId.slice(0, 8)}...
    </div>
  );
};

export default SessionInfo;
